export enum GroupByEnum {
  REPORT_DATE = 'report_date',
  OPERATION = 'operation_id',
  COUNTRY = 'country_code',
  PLACEMENT = 'tag_id',
  LINK = 'link',
}
